/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurableParameterDto } from './ConfigurableParameterDto';
import {
    ConfigurableParameterDtoFromJSON,
    ConfigurableParameterDtoFromJSONTyped,
    ConfigurableParameterDtoToJSON,
    ConfigurableParameterDtoToJSONTyped,
} from './ConfigurableParameterDto';

/**
 * A configurable pricing variable of the tunnel in the re-pricing model.
 * @export
 * @interface RetarificationVariableDto
 */
export interface RetarificationVariableDto {
    /**
     * Variable value of the tunnel, as expected by the comparator.
     * @type {string}
     * @memberof RetarificationVariableDto
     */
    variableValueId: string;
    /**
     * 
     * @type {string}
     * @memberof RetarificationVariableDto
     */
    variableId: string;
    /**
     * 
     * @type {string}
     * @memberof RetarificationVariableDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RetarificationVariableDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RetarificationVariableDto
     */
    valeurTunnel: number;
    /**
     * Value on the quote, null when the quote does not carry the variable.
     * @type {number}
     * @memberof RetarificationVariableDto
     */
    valeurDevis?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RetarificationVariableDto
     */
    unite?: string | null;
    /**
     * Allowed values, null for a free input.
     * @type {ConfigurableParameterDto}
     * @memberof RetarificationVariableDto
     */
    parametres?: ConfigurableParameterDto | null;
}

/**
 * Check if a given object implements the RetarificationVariableDto interface.
 */
export function instanceOfRetarificationVariableDto(value: object): value is RetarificationVariableDto {
    if (!('variableValueId' in value) || value['variableValueId'] === undefined) return false;
    if (!('variableId' in value) || value['variableId'] === undefined) return false;
    if (!('valeurTunnel' in value) || value['valeurTunnel'] === undefined) return false;
    return true;
}

export function RetarificationVariableDtoFromJSON(json: any): RetarificationVariableDto {
    return RetarificationVariableDtoFromJSONTyped(json, false);
}

export function RetarificationVariableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetarificationVariableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'variableValueId': json['variableValueId'],
        'variableId': json['variableId'],
        'code': json['code'] == null ? undefined : json['code'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'valeurTunnel': json['valeurTunnel'],
        'valeurDevis': json['valeurDevis'] == null ? undefined : json['valeurDevis'],
        'unite': json['unite'] == null ? undefined : json['unite'],
        'parametres': json['parametres'] == null ? undefined : ConfigurableParameterDtoFromJSON(json['parametres']),
    };
}

export function RetarificationVariableDtoToJSON(json: any): RetarificationVariableDto {
    return RetarificationVariableDtoToJSONTyped(json, false);
}

export function RetarificationVariableDtoToJSONTyped(value?: RetarificationVariableDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'variableValueId': value['variableValueId'],
        'variableId': value['variableId'],
        'code': value['code'],
        'libelle': value['libelle'],
        'valeurTunnel': value['valeurTunnel'],
        'valeurDevis': value['valeurDevis'],
        'unite': value['unite'],
        'parametres': ConfigurableParameterDtoToJSON(value['parametres']),
    };
}

